import PropTypes from 'prop-types';
import React from 'react';

import TextField from '@bibliocommons/text-field';

import { listsHeroSectionShape, listsHeroSectionValidationShape } from 'app/shapes/admin/browse/home';
import { LISTS_HERO_NUM_MAX_LIST_URLS, LISTS_HERO_NUM_MIN_LIST_URLS } from 'app/constants/admin/browse/home';
import EditorListUrls from './shared/EditorListUrls';

import './SectionEditorListsHero.scss';

const SectionEditorListsHero = ({ onChange, section: listsHeroSection, validation }) => {
  const { heading, listUrls, sectionId } = listsHeroSection;

  const handleHeadingChange = newHeading => {
    onChange({
      ...listsHeroSection,
      heading: newHeading
    });
  };

  const handleListUrlsChange = newListUrls => {
    onChange({
      ...listsHeroSection,
      listUrls: newListUrls
    });
  };

  const headingInputId = `SectionEditorListsHero_${sectionId}_Heading`;
  const editorListUrlsKey = `${sectionId}_EditorListUrls`;

  return (
    <div className="cp-admin-browse-home-editor-lists-hero">
      <p className="rules">
        {LISTS_HERO_NUM_MIN_LIST_URLS}&ndash;{LISTS_HERO_NUM_MAX_LIST_URLS} lists can be added.
      </p>

      <div className="heading-field-wrapper">
        <TextField
          errorMessage={validation.errorByAttribute.heading}
          id={headingInputId}
          label="Screen reader heading"
          onChange={handleHeadingChange}
          type="text"
          value={heading}
        />
      </div>

      <EditorListUrls
        key={editorListUrlsKey}
        listUrls={listUrls}
        listUrlErrors={validation.errorByAttribute.listUrls}
        numRowsMax={LISTS_HERO_NUM_MAX_LIST_URLS}
        numRowsMin={LISTS_HERO_NUM_MIN_LIST_URLS}
        onChange={handleListUrlsChange}
      />
    </div>
  );
};

SectionEditorListsHero.defaultProps = {
  validation: {
    isValid: true,
    errorByAttribute: {
      heading: '',
      listUrls: []
    }
  }
};

SectionEditorListsHero.propTypes = {
  onChange: PropTypes.func.isRequired,
  section: listsHeroSectionShape.isRequired,
  validation: listsHeroSectionValidationShape
};

export default SectionEditorListsHero;
